import { memo } from 'react';

import { WorkspaceMemberType } from '@air/api/types';
import { DropdownMenuSeparator } from '@air/primitive-dropdown-menu';

import { CreditUsageMeterBar } from '~/components/CreditUsageMeter/CreditUsageMeterBar';
import { CreditUsageMeterCount } from '~/components/CreditUsageMeter/CreditUsageMeterCount';
import { CreditUsageMeterLegend } from '~/components/CreditUsageMeter/CreditUsageMeterLegend';
import { CreditUsageMeterResetDate } from '~/components/CreditUsageMeter/CreditUsageMeterResetDate';
import { useCurrentWorkspaceMember } from '~/swr-hooks/members/useCurrentWorkspaceMember';
import { useCreditStats } from '~/swr-hooks/workspaces/useCreditStats';

export const WorkspaceHeaderInformationDropdownCreditUsage = memo(() => {
  const { data: creditStats } = useCreditStats();
  const { currentWorkspaceMember } = useCurrentWorkspaceMember();

  if (!creditStats?.allocated || !currentWorkspaceMember || currentWorkspaceMember.type === WorkspaceMemberType.guest) {
    return null;
  }

  return (
    <>
      <div className="flex flex-col gap-2 px-3 py-2">
        <p className="font-semibold text-10 text-gray-10 uppercase tracking-wider">Workspace Credit Usage</p>
        <CreditUsageMeterCount allocated={creditStats.allocated} used={creditStats.used} />
        <div className="flex flex-col gap-1">
          <CreditUsageMeterBar allocated={creditStats.allocated} used={creditStats.used} className="h-3 bg-gray-4" />
          <CreditUsageMeterLegend used={creditStats.used} />
        </div>
        <CreditUsageMeterResetDate nextCycleStartAt={creditStats.nextCycleStartAt} />
      </div>
      <DropdownMenuSeparator />
    </>
  );
});

WorkspaceHeaderInformationDropdownCreditUsage.displayName = 'WorkspaceHeaderInformationDropdownCreditUsage';
